import type { FaireProductEntity } from "../../entity_types/product";

export const p_kzyjhb5msm: FaireProductEntity = {
  token: "p_kzyjhb5msm",
  type: "product",
  name: "Koroneiki Extra Virgin Olive Oil - 250mL",
  brandToken: "b_8h4l3mg9te",
  brandName: "Bari Olive Oil",
  imageUrl:
    "https://cdn.faire.com/fastly/0be41e2aa1d30a4be39970f72810184a6761f71dc306b953b1e577d895bb1b5a.png",
  galleryImageUrls: [],
  priceDollars: 12.47,
  description:
    "California Extra Virgin Olive Oil featuring a bold, peppery flavor. It's non-GMO. It's COOC-Certified. It's Kosher. It's a perfect addition to your family's table. All of our Koroneiki olives are locally-sourced from groves in the heart of California in small batches to ensure olives are milled within twenty-four hours of harvest. In addition, our olive oil is always unfiltered. We use a natural racking process to provide you the highest quality olive oil possible.",
  tags: [],
  msrpDollars: 22.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:58.430Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
